<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M9.99999 9.99913C11.2273 9.99913 12.2222 9.00421 12.2222 7.77691C12.2222 6.54961 11.2273 5.55469 9.99999 5.55469C8.77269 5.55469 7.77777 6.54961 7.77777 7.77691C7.77777 9.00421 8.77269 9.99913 9.99999 9.99913Z"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.44557 17.5296C5.90223 17.3651 5.53668 16.824 5.65779 16.2685C6.09446 14.2718 7.87223 12.7773 10 12.7773C12.1278 12.7773 13.9056 14.2718 14.3422 16.2685C14.4633 16.8229 14.0989 17.3651 13.5545 17.5296C12.6422 17.8051 11.4311 18.0562 10 18.0562C8.5689 18.0562 7.35779 17.8062 6.44557 17.5296Z"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.2778 5.27865C16.1983 5.27865 16.9444 4.53245 16.9444 3.61198C16.9444 2.6915 16.1983 1.94531 15.2778 1.94531C14.3573 1.94531 13.6111 2.6915 13.6111 3.61198C13.6111 4.53245 14.3573 5.27865 15.2778 5.27865Z"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.0933 8.05327C15.1544 8.05105 15.2155 8.04883 15.2778 8.04883C17.1367 8.04883 18.6989 9.32327 19.1367 11.0455C19.2811 11.6133 18.9022 12.1788 18.3389 12.3422C17.6244 12.5488 16.72 12.7333 15.6689 12.7699"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.72221 5.27865C5.64268 5.27865 6.38888 4.53245 6.38888 3.61198C6.38888 2.6915 5.64268 1.94531 4.72221 1.94531C3.80173 1.94531 3.05554 2.6915 3.05554 3.61198C3.05554 4.53245 3.80173 5.27865 4.72221 5.27865Z"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.90668 8.05327C4.84557 8.05105 4.78446 8.04883 4.72224 8.04883C2.86335 8.04883 1.30112 9.32327 0.863346 11.0455C0.718902 11.6133 1.09779 12.1788 1.66112 12.3422C2.37557 12.5488 3.28001 12.7333 4.33112 12.7699"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
